import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError, notifySuccess} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import dashboard8 from '../locales/dashboard8.json';
import {Label, Select} from '../../../common/components/form';
import {IconLink} from "../../../common/components/link";
import VSelect from "../../../common/components/form/VSelect";
import {formatDate} from "../../../helpers/utils";

class DashboardBox8 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			allWorkOrders: [],
			businessUnitsList: [],
			jobStatusesList: [],
			workOrdersList: [],
			userApprovedStatusesList:[],
			clientApprovedStatusesList:[],
			searchedWorkOrders: [],
			searchForm: {
				business_unit_id: '',
				job_status: 'Open',
				work_order_id: '',
				user_approved_status: '',
				client_approved_status: ''
			}
		}
	}

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard8);
		this.loadDashboard();
		const {searchForm} = this.state;
		this.loadDashboardSearchFormSubmit(searchForm);
	}

	updateSearchFormState = (object) => {
		const { allWorkOrders, searchForm } = this.state;

		const newSearchForm = {
			...this.state.searchForm,
			...object
		};
		this.setState({searchForm: newSearchForm});

		if("business_unit_id" in object || "job_status" in object) {
			let businessUnitId = searchForm.business_unit_id;
			let jobStatus = searchForm.job_status;

			if ("business_unit_id" in object) {
				businessUnitId = object.business_unit_id;
			}

			if ("job_status" in object) {
				jobStatus = object.job_status;
			}

			const filteredWorkOrders = allWorkOrders.filter(item => {
				if(businessUnitId && jobStatus) {
					return item.business_unit_id === businessUnitId && item.job_status === jobStatus;
				} else if(businessUnitId) {
					return item.business_unit_id === businessUnitId;
				} else if(jobStatus) {
					return item.job_status === jobStatus;
				} else {
					return true;
				}
			});
			const workOrdersList = filteredWorkOrders.map(item => ({
				value: item.id,
				label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
			}));

			this.setState({workOrdersList: workOrdersList});
		}

		this.loadDashboardSearchFormSubmit(newSearchForm);
	};

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/8`);

			const businessUnitsList = response.data.business_units.map(item => ({
				value: item.id,
				label: item.code + ' - ' + item.name
			}));

			const jobStatusesList = response.data.job_statuses.map(item => ({
				value: item,
				label: item
			}));

			const allWorkOrders = response.data.work_orders;
			const workOrdersList = response.data.work_orders.filter(item => item.job_status === 'Open').map(item => ({
				value: item.id,
				label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
			}));

			const userApprovedStatusesList = response.data.user_approved_statuses.map(item => ({
				value: item,
				label: item
			}));

			const clientApprovedStatusesList = response.data.client_approved_statuses.map(item => ({
				value: item,
				label: item
			}));

			this.setState({
				isLoading: false,
				allWorkOrders: allWorkOrders,
				businessUnitsList: businessUnitsList,
				jobStatusesList: jobStatusesList,
				workOrdersList: workOrdersList,
				userApprovedStatusesList: userApprovedStatusesList,
				clientApprovedStatusesList: clientApprovedStatusesList
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	loadDashboardSearchFormSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		// if (!values.business_unit_id && !values.work_order_id) {
		// 	this.setState({searchedWorkOrders: []});
		// 	return;
		// }

		this.setState({isLoading: true});
		try {
			const formData = Object.assign({}, values);

			const response = await api.post('/dashboard/8/search', formData);
			notifySuccess(response.message);

			const searchedWorkOrders = response.data.work_orders;

			this.setState({isLoading: false, searchedWorkOrders: searchedWorkOrders});
		} catch (error) {
			this.setState({isLoading: false});
			notifyError(error.message);
		}
	};

	render() {
		const {translate} = this.props;
		const {businessUnitsList, jobStatusesList, workOrdersList, userApprovedStatusesList, clientApprovedStatusesList, searchForm, searchedWorkOrders} = this.state;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					<div className="box">
						<div className="box-body with-top-padding">
							<div className="row">
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_business_unit_id')}/>
										<VSelect list={businessUnitsList} clearable={true} value={searchForm.business_unit_id} onChange={selected => this.updateSearchFormState({business_unit_id: selected || '', work_order_id: ''})}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_work_order_id')}/>
										<VSelect list={workOrdersList} clearable={true} value={searchForm.work_order_id} onChange={selected => this.updateSearchFormState({work_order_id: selected || ''})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_job_status')}/>
										<Select list={jobStatusesList} value={searchForm.job_status} onChange={selected => this.updateSearchFormState({job_status: selected, work_order_id: ''})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_user_approved_status')}/>
										<Select list={userApprovedStatusesList} clearable={true} value={searchForm.user_approved_status} onChange={selected => this.updateSearchFormState({user_approved_status: selected})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_client_approved_status')}/>
										<Select list={clientApprovedStatusesList} clearable={true} value={searchForm.client_approved_status} onChange={selected => this.updateSearchFormState({client_approved_status: selected})} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{
						(searchedWorkOrders.length > 0) && searchedWorkOrders.map((workOrder, index) => (
							<div className="info-box info-box-icon-left" key={`dashboard_page_box_${index}`}>
								<span className="info-box-icon">
									{(workOrder.client_approved_status === 'Approved') && (
										<i className="fa fa-check-circle-o fa-2x" style={{"color": "#00a65a"}}/>
									)}
								</span>
								<div className="info-box-content" style={{paddingBottom: "0"}}>
									<div className="row">
										<div className="col-md-2">
											<span className="info-box-text">Work Order</span>
											<span className="info-box-number">
												<IconLink type="link" to={`/work-orders/detail/${workOrder.id}`} text={workOrder.code}/>
											</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">Customer</span>
											<span className="info-box-number">{workOrder.customer ? workOrder.customer.name : ''}</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">Job Description</span>
											<span className="info-box-number" style={{maxHeight: "50px", overflow: "scroll"}}>{workOrder.job_description}</span>
										</div>
										<div className="col-md-1">
											<span className="info-box-text">Revision</span>
											<span className="info-box-number">{workOrder.revision}</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">WO PTI Status</span>
											<span className="info-box-number">{workOrder.user_approved_status}</span>
											<span>{workOrder.user_approved_date ? formatDate(workOrder.user_approved_date, 'MMM DD, YYYY') : ''}</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">WO Client Status</span>
											<span className="info-box-number">{workOrder.client_approved_status}</span>
											<span>{workOrder.client_approved_date ? formatDate(workOrder.client_approved_date, 'MMM DD, YYYY') : ''}</span>
										</div>
									</div>

								</div>
							</div>
						))
					}
				</section>

			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError,
	notifySuccess
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox8);
